"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AuthContext_1 = require("../Auth/AuthContext");
const PlantOptionsGrid_1 = __importDefault(require("../components/PlantOptions/PlantOptionsGrid"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const utils_1 = require("../Auth/utils");
const PlantOptions = (props) => {
    const { user } = (0, AuthContext_1.useAuth)();
    return (react_1.default.createElement("div", { className: "flex w-full" },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, "Qualit\u00E4ten")),
        (0, utils_1.isAllowed)(user, ['read_plant_option', 'update_plant_option', 'delete_plant_option', 'create_plant_option']) ? (react_1.default.createElement(PlantOptionsGrid_1.default, null)) : null));
};
exports.default = PlantOptions;
